import { render, staticRenderFns } from "./AddCouriers.vue?vue&type=template&id=a743a8c0"
import script from "./AddCouriers.vue?vue&type=script&lang=js"
export * from "./AddCouriers.vue?vue&type=script&lang=js"
import style0 from "./AddCouriers.vue?vue&type=style&index=0&id=a743a8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports